import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { News, AboutUs, Chef, FindUs, Footer, Header, Intro, Laurels, SpecialMenu } from './container';
import { Navbar, VacationNotice } from './components';
import './App.css';

const App = () => (
  <div>
    <VacationNotice />
    <Navbar />
    <Header />
    <AboutUs />
    <SpecialMenu />
    <Chef />
    <Intro />
    <Laurels />
    <FindUs />
    <News />
    <Footer />
    <CookieConsent
      buttonText="Ho capito / I understand"
      style={{
        background: 'rgba(46, 36, 26, 0.96)',
        color: '#F5EFDB',
        fontFamily: "'Open Sans', sans-serif",
        fontSize: '14px',
        alignItems: 'center',
        borderTop: '1px solid rgba(220, 202, 135, 0.35)',
      }}
      buttonStyle={{
        background: '#DCCA87',
        color: '#2E241A',
        fontFamily: "'Open Sans', sans-serif",
        fontWeight: 600,
        fontSize: '13px',
        borderRadius: '999px',
        padding: '9px 20px',
      }}
    >
      This website uses cookies to enhance the user experience.
    </CookieConsent>
  </div>
);

export default App;
